export default __webpack_public_path__ + "static/media/gallery_12.1ee41a05.jpg";